import React from 'react';
import classNames from 'classnames';

import css from './IconBook.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element}
 */
const IconBook = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.333496 8.76243V1.33191C0.333496 0.599795 0.924363 0.00505537 1.6551 0.0499664C2.30601 0.0899716 3.07582 0.169048 3.66683 0.325003C4.3663 0.50958 5.19757 0.902714 5.855 1.25035C6.05974 1.35861 6.27746 1.4337 6.50028 1.47602V11.5951C6.29828 11.5506 6.1012 11.4787 5.91511 11.3795C5.24879 11.0244 4.3878 10.6125 3.66683 10.4223C3.08236 10.2681 2.32302 10.189 1.67674 10.1486C0.937527 10.1024 0.333496 9.50308 0.333496 8.76243ZM2.45488 3.51497C2.18698 3.44799 1.91552 3.61088 1.84854 3.87877C1.78157 4.14667 1.94445 4.41814 2.21235 4.48511L4.87901 5.15178C5.14691 5.21875 5.41838 5.05587 5.48535 4.78798C5.55233 4.52008 5.38945 4.24861 5.12155 4.18164L2.45488 3.51497ZM2.45488 6.18164C2.18698 6.11466 1.91552 6.27754 1.84854 6.54544C1.78157 6.81334 1.94445 7.0848 2.21235 7.15178L4.87901 7.81845C5.14691 7.88542 5.41838 7.72254 5.48535 7.45464C5.55233 7.18674 5.38945 6.91528 5.12155 6.8483L2.45488 6.18164Z"
        fill="#5BA4EA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.50028 11.5951C7.7022 11.5505 7.89919 11.4787 8.08522 11.3795C8.75154 11.0244 9.61253 10.6125 10.3335 10.4223C10.918 10.2681 11.6773 10.189 12.3236 10.1486C13.0628 10.1024 13.6668 9.50308 13.6668 8.76243V1.28884C13.6668 0.573871 13.1027 -0.0130176 12.3881 0.011872C11.6358 0.0380802 10.6981 0.116059 10.0002 0.325003C9.39508 0.50615 8.69037 0.869496 8.11606 1.20188C7.92177 1.31432 7.71412 1.39691 7.50028 1.44929V11.5951ZM11.7882 4.48511C12.0561 4.41814 12.219 4.14667 12.152 3.87877C12.085 3.61088 11.8136 3.44799 11.5457 3.51497L8.87901 4.18164C8.61112 4.24861 8.44824 4.52008 8.51521 4.78798C8.58218 5.05587 8.85365 5.21875 9.12155 5.15178L11.7882 4.48511ZM11.7882 7.15178C12.0561 7.0848 12.219 6.81334 12.152 6.54544C12.085 6.27754 11.8136 6.11466 11.5457 6.18164L8.87901 6.8483C8.61112 6.91528 8.44824 7.18674 8.51521 7.45464C8.58218 7.72254 8.85365 7.88542 9.12155 7.81845L11.7882 7.15178Z"
        fill="#5BA4EA"
      />
    </svg>
  );
};

export default IconBook;
